module.exports = __webpack_public_path__ + "static/img/newlabel.8401f378.png";